export default "__VITE_ASSET__343b72ba__"